import React from "react";
import { NavLink } from "react-router-dom";
import "./footnav.css";
import schlogo from "../resources/images/School Crest.png";
import {
  FaWhatsapp,
  FaInstagram,
  FaTelegram,
  FaPhone,
  FaYoutube,
} from "react-icons/fa";
import QuickContact from "./quick-contact";

function Footer() {
  return (
    <div className="footer">
      <div className="bg-pattern"></div>
      <div className="foot-links">
        <div className="school-details">
          {/* <span>V</span> */}
          <h3>STAR OF THE EAST SCHOOL COMPLEX</h3>
          <img src={schlogo} alt="" />
          <div className="socials">
            <FaWhatsapp id="contact-social-icon" />
            <FaInstagram id="contact-social-icon" />
            <FaTelegram id="contact-social-icon" />
            <FaPhone id="contact-social-icon" />
            <FaYoutube id="contact-social-icon" />
          </div>
          <QuickContact />
        </div>
        <div className="useful-links">
          <h3>USEFUL LINKS</h3>
          <NavLink className="use-links" to="/About">
            About Us
          </NavLink>
          <NavLink className="use-links" to="/Academics">
            Academics{" "}
          </NavLink>
          <NavLink className="use-links" to="/Contact">
            Contact
          </NavLink>
          <NavLink className="use-links" to="/Events">
            Events
          </NavLink>
          <NavLink className="use-links" to="/Scholarships">
            Scholarships and Support
          </NavLink>
          <NavLink className="use-links" to="/Admissions">
            Admissions
          </NavLink>
          <NavLink className="use-links" to="/">
            Student's Portal
          </NavLink>
        </div>
        <div className="email-subscriptions">
          <h3>SUBSCRIBE TO OUR NEWS LETTERS</h3>
          <div className="input-wrapper">
            <input type="email" placeholder="Subscribe to our mail updates" />
            <button>Subscribe</button>
          </div>
        </div>
      </div>
      <p id="contact-details">
        &copy; {new Date().getFullYear()} Star of the East School Complex,
        Taifa, Ghana | T: +233552851039 | E: me@gmail.com | Ghana Post GPS
        Address: AG-000-000
      </p>
      <p>
        Developed By :{" "}
        <span style={{ color: "#f47c2c", cursor: "pointer" }}>
          IFIX WEB SERVICES
        </span>
      </p>
    </div>
  );
}

export default Footer;
